import { Dropdown } from '@nextui-org/react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s};
  line-height: ${({ theme }) => theme.lineHeight.xs};
  margin: 0 0 0.25rem 0.5rem;
`;

export interface StyledDropdownProps {
  css?: any;
}

export const StyledDropdown = styled(Dropdown).attrs<StyledDropdownProps>(({ css }) => ({
  ...(css ?? {}),
  isBordered: false,
  offset: 4,
}))``;

export interface DropDownButtonProps {
  $isActive?: boolean;
  $isDisabled?: boolean;
  children?: React.ReactNode;
}

export const DropDownButton = styled(Dropdown.Button).attrs<DropDownButtonProps>((props) => {
  const { $isActive, $isDisabled, theme, css } = props as DropDownButtonProps & { theme: any; css?: any };
  const isActive = $isActive;
  const isDisabled = $isDisabled;
  return {
    css: {
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      color: isActive ? theme.colors.primary : theme.colors.primary.c500,
      background: isActive ? theme.colors.primary.c200 : theme.colors.primary.c050,
      height: 'calc($13 - 2px)',
      width: '5.8rem',
      'border-radius': '$xxs',
      'border-color': 'transparent',
      'padding-left': '$6',
      'padding-right': '$6',
      '&.nextui-dropdown-button': {
        justifyContent: 'space-between',
      },
      '&.nextui-dropdown-button[aria-haspopup="true"].nextui-dropdown-button[aria-expanded="true"]': {
        transform: 'unset',
      },
      ...(css ?? {}),
    },
  };
})``;

interface DropDownMenuProps {
  $active?: boolean;
  $isDisabled?: boolean;
}

export const DropDownMenu = styled(Dropdown.Menu)<DropDownMenuProps>`
  width: 5.8rem;
  border-radius: ${({ theme }) => theme.borderRadius};
  color: ${({ $active, theme }) => String($active ? theme.colors.primary : theme.colors.primary.c500)};
  background: ${({ $active, theme }) => String($active ? theme.colors.primary.c200 : theme.colors.primary.c050)};
  height: 2.25rem;
  display: flex;
  justify-content: flex-start;
  min-width: 6rem;

  & .nextui-dropdown-item {
    height: unset;
    padding: 0 0.4rem;
    background: transparent;
    color: ${({ $active, theme }) => String($active ? theme.colors.primary : theme.colors.primary.c500)};
  }
`;

export const DropDownItemContainer = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  height: 2rem;
`;

export const DropDownItemText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s};
`;

export const DropDownItemDescription = styled(DropDownItemText)`
  color: ${({ theme }) => theme.colors.primary.c300};
  font-style: italic;
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary.c050};
`;
